import { Flex, Select, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { options } from './RuleTypeSection.constants';
import { useRuleTypeSection } from './RuleTypeSection.hooks';
import { messages } from './RuleTypeSection.messages';
import { RuleTypeSectionProps } from './RuleTypeSection.types';

export const RuleTypeSection = memo<RuleTypeSectionProps>((props) => {
    const { ruleIndex } = props;

    const { value, handleChange } = useRuleTypeSection(ruleIndex);

    return (
        <Flex container alignItems='center' data-qa='rule-schedule-type'>
            <Flex size={12} block>
                <Text font='label' color='midnight70' fontSize='small'>
                    {messages.scheduleTypeText}
                </Text>
            </Flex>

            <Flex size={12} block>
                <Select
                    size='small'
                    qa='schedule-type'
                    value={value}
                    items={options}
                    clearable={false}
                    onChange={handleChange}
                />
            </Flex>
        </Flex>
    );
});

RuleTypeSection.displayName = 'RuleTypeSection';
